module.exports = __webpack_public_path__ + "static/pic03@5x-e8930e9033c6e8a55238ec1755fcf6bb.jpg";